/** Manages trip requests*/

import React, { Component } from "react";
import PropTypes from "prop-types";
import ImmutablePropTypes from "react-immutable-proptypes";
import { List, Map } from "immutable";
import moment from "moment";

import { getOffers } from "../api";

import FlightRequirementEditor from "../request/FlightRequirementEditor";
import AccommodationRequirementEditor from "../request/AccommodationRequirementEditor";

class TripRequestEditor extends Component {
  constructor() {
    super();

    this.state = {
      travelRequest: undefined,
      flightTravelRequest: undefined,
      accommodationTravelRequest: undefined,
      vehicleTravelRequest: undefined,
      flightTravelRequestChanged: false,
      accommodationTravelRequestChanged: false,
      vehicleTravelRequestChanged: false,
      getOffersResponseLoading: false
    };
  }

  componentDidMount() {
    if (this.props.view === "book-a-flight") {
      this.setState({
        travelRequest: this.props.tripRequest,
        flightTravelRequest: this.props.tripRequest
      });
    } else if (this.props.view === "get-a-room") {
      this.setState({
        travelRequest: this.props.tripRequest,
        accommodationTravelRequest: this.props.tripRequest
      });
    }
    if (this.props.view === "rent-a-car") {
      this.setState({
        travelRequest: this.props.tripRequest,
        vehicleTravelRequest: this.props.tripRequest
      });
    }
  }

  componentDidUpdate(previousProps) {
    if (this.props.tripRequest !== previousProps.tripRequest) {
      this.setState({
        travelRequest: this.props.tripRequest
      });
      if (!this.state.flightTravelRequestChanged && this.props.view === "book-a-flight") {
        this.setState({
          flightTravelRequest: this.props.tripRequest
        });
      }
      if (!this.state.accommodationTravelRequestChanged && this.props.view === "get-a-room") {
        this.setState({
          accommodationTravelRequest: this.props.tripRequest
        });
      }
      if (!this.state.vehicleTravelRequestChanged && this.props.view === "rent-a-car") {
        this.setState({
          vehicleTravelRequest: this.props.tripRequest
        });
      }
    }
  }

  updateRequest(travelRequest) {
    this.setState({ errorMessage: "" });
    if (this.props.view === "book-a-flight") {
      this.setState({
        flightTravelRequest: travelRequest,
        flightTravelRequestChanged: true
      });
    } else if (this.props.view === "get-a-room") {
      this.setState({
        accommodationTravelRequest: travelRequest,
        accommodationTravelRequestChanged: true
      });
    }
    if (this.props.view === "rent-a-car") {
      this.setState({
        vehicleTravelRequest: travelRequest,
        vehicleTravelRequestChanged: true
      });
    }
  }

  resetRequest() {
    if (this.props.view === "book-a-flight") {
      this.setState({
        flightTravelRequest: this.state.travelRequest,
        flightTravelRequestChanged: false
      });
    } else if (this.props.view === "get-a-room") {
      this.setState({
        accommodationTravelRequest: this.state.travelRequest,
        accommodationTravelRequestChanged: false
      });
    }
    if (this.props.view === "rent-a-car") {
      this.setState({
        vehicleTravelRequest: this.state.travelRequest,
        vehicleTravelRequestChanged: false
      });
    }
  }

  /** New airport(s) are discovered by user */
  onNewAirports(airports = List()) {
    const { referenceData } = this.props;
    const airportByIata = referenceData.airportByIata;
    const newByIata = airports.reduce((m, airport) => m.set(airport.get("iataCode"), airport), Map());
    if (airportByIata) {
      referenceData.airportByIata = airportByIata.merge(newByIata);
    } else {
      referenceData.airportByIata = newByIata;
    }
    this.props.onUpdateReferenceData(referenceData);
  }

  requestNewOffers() {
    const em = this.validateRequestAndGetMessage();
    if (em !== "") {
      this.setState({ errorMessage: em });
    } else {
      this.setState({ errorMessage: "" });

      this.props.offersRequestStatus({
        getOffersResponseLoading: true,
        getOffersResponseError: null,
        loadingProgress: 25
      });

      this.setState({ getOffersResponseLoading: true });

      const serviceRequirementType =
        this.props.view === "book-a-flight"
          ? "FlightRequirement"
          : this.props.view === "get-a-room"
          ? "AccommodationRequirement"
          : "VehicleRequirement";
      const prefix = this.props.view === "book-a-flight" ? "flight" : this.props.view === "get-a-room" ? "accommodation" : "vehicle";
      const request = this.state[prefix + "TravelRequest"].updateIn(["required"], r =>
        r.reduce((nr, li) => nr.push(li.set("isA", serviceRequirementType)), List())
      );

      getOffers(request)
        .then((getOffersResponse = Map()) => {
          let newState = {};
          newState[prefix + "TravelRequestChanged"] = false;
          newState.getOffersResponseLoading = false;
          this.setState({ newState });
          this.props.onUpdateOffersResponse(this.props.view, getOffersResponse);
          this.props.offersRequestStatus({
            getOffersResponseLoading: false,
            getOffersResponseError: null,
            loadingProgress: 100
          });
        })
        .catch(getOffersResponseError => {
          console.warn(getOffersResponseError);
          this.props.offersRequestStatus({
            getOffersResponseLoading: false,
            getOffersResponseError,
            loadingProgress: 100
          });
        });
    }
  }

  validateRequestAndGetMessage() {
    const { view } = this.props;
    if (view === "book-a-flight") {
      if (this.state.flightTravelRequest.get("required", List()).isEmpty()) {
        return "Please add at least one request.";
      }
      for (let i = 0; i < this.state.flightTravelRequest.get("required").count(); i++) {
        const request = this.state.flightTravelRequest.getIn(["required", i]);
        if (!request.has("from")) {
          return "Origin airport is missing.";
        }
        if (!request.has("to")) {
          return "Destination airport is missing.";
        }
        if (!request.has("departureDate")) {
          return "Departure date is missing.";
        }
        if (moment(request.get("departureDate")).isBefore(moment())) {
          return "Departure date cannot be a past date.";
        }
      }
    }
    if (view === "get-a-room") {
      // console.log(this.state.accommodationTravelRequest.toString());
      if (this.state.accommodationTravelRequest.get("required", List()).isEmpty()) {
        return "Please add at least one request.";
      }
      for (let i = 0; i < this.state.accommodationTravelRequest.get("required").count(); i++) {
        const request = this.state.accommodationTravelRequest.getIn(["required", i]);
        if (!request.has("checkIn")) {
          return "Check in date is missing.";
        }
        if (!request.has("checkOut")) {
          return "Check out date is missing.";
        }
        if (!request.has("totalUnitsRequired")) {
          return "Please select number of rooms required.";
        }
        if (!request.has("approximateLocation")) {
          return "Please select desired location of stay.";
        }
      }
    }
    if (view === "rent-a-car") {
      // eslint-disable-next-line no-empty
    }
    return ""; // no error message -> no error
  }

  render() {
    const { view, referenceData } = this.props;
    const {
      errorMessage,
      flightTravelRequestChanged,
      accommodationTravelRequestChanged,
      getOffersResponseLoading,
      flightTravelRequest,
      accommodationTravelRequest = Map()
    } = this.state;
    const travelRequestChanged = view === "book-a-flight" ? flightTravelRequestChanged : accommodationTravelRequestChanged;
    return (
      <div>
        {view === "book-a-flight" ? (
          <FlightRequirementEditor
            request={flightTravelRequest}
            onRequestChange={this.updateRequest.bind(this)}
            airportByIata={referenceData.airportByIata}
            onNewAirports={this.onNewAirports.bind(this)}
          />
        ) : view === "get-a-room" ? (
          <AccommodationRequirementEditor request={accommodationTravelRequest} onRequestChange={this.updateRequest.bind(this)} />
        ) : (
          <div>Rent a car: not implemented yet</div>
        )}
        <p className="container request-changed-controls text-right">
          {errorMessage ? <span style={{ marginRight: "25px", padding: "10px", color: "rgb(255, 36, 10)" }}>{errorMessage}</span> : null}
          {travelRequestChanged && !getOffersResponseLoading && (
            <button type="button" className="btn btn-nx btn-danger" onClick={this.resetRequest.bind(this)}>
              Reset changes
            </button>
          )}
          <button type="button" className="btn btn-primary min-width-140" onClick={this.requestNewOffers.bind(this)}>
            Get offers
          </button>
        </p>
      </div>
    );
  }
}

TripRequestEditor.propTypes = {
  // The travel request currently displayed
  tripRequest: ImmutablePropTypes.map,
  // view - String from ('book-a-flight','get-a-room','rent-a-car')
  view: PropTypes.string.isRequired,
  // JS Object containing shared reference data.
  referenceData: PropTypes.object,
  // Called to update response object
  onUpdateOffersResponse: PropTypes.func.isRequired,
  // Called to update reference data object
  onUpdateReferenceData: PropTypes.func,
  // Called to signal status/progress new offers request
  offersRequestStatus: PropTypes.func.isRequired
};

export default TripRequestEditor;



// WEBPACK FOOTER //
// ./src/ndc/request/TripRequestEditor.js